module.exports = __webpack_public_path__ + "static/img/car_bcg3.1e77c614.png";